<template>
  <div class="agreement" @click="toAgreement">《Privacy Agreement》</div>
</template>

<script>
export default {
  methods: {
    toAgreement () {
      this.$router.push({ name: 'agreementPage', query: { title: 'Privacy Agreement', type: 'privacy' } })
    }
  }
}
</script>

<style scoped lang="less">
.agreement {
  color: #9695A9;
  font-size: 14px;
  padding: 50px 0;
}
</style>
